import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

@Component
export class FormInputRow extends Vue {

  render (h: CreateElement) {
    return <div class='row'>
      <div class='input-label'>
        {this.$slots.label}
      </div>

      <div class='inputs'>
        {this.$slots.default}
      </div>

      {this.$slots.units ? <div class='slot units'>
        {this.$slots.units}
      </div> : ''}
    </div>
  }
}
